/* Reviews Section - "Proof Before The Spec Sheet" Swiper init */
(function () {
  function initReviewsProof() {
    if (typeof Swiper === 'undefined') return false;

    var containers = document.querySelectorAll('.swiper-reviews-proof');
    var initedAny = false;

    containers.forEach(function (el) {
      if (el.dataset.rpInited === '1') return;

      var root = el.closest('.reviews-proof') || document;

      // Desktop slides-per-view. Fractional values (e.g. 4.5, 5.2) make the
      // next slide peek in from the right edge, matching the design.
      var perView = parseFloat(el.dataset.perView) || 4.2;

      el.dataset.rpInited = '1';
      initedAny = true;

      new Swiper(el, {
        loop: true,
        spaceBetween: 16,
        slidesPerView: 1.40,
        watchOverflow: true,
        navigation: {
          nextEl: root.querySelector('.reviews-proof-next'),
          prevEl: root.querySelector('.reviews-proof-prev'),
        },
        breakpoints: {
          600: { slidesPerView: 1.9, spaceBetween: 16 },
          750: { slidesPerView: 2.4, spaceBetween: 16 },
          990: { slidesPerView: Math.min(perView, 3.2), spaceBetween: 16 },
          1200: { slidesPerView: Math.min(perView, 4.4), spaceBetween: 16 },
          1500: { slidesPerView: perView, spaceBetween: 16 },
        },
      });
    });

    return initedAny;
  }

  function boot() {
    if (initReviewsProof()) return;
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (initReviewsProof() || tries > 40) clearInterval(timer);
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', initReviewsProof);

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector('.swiper-reviews-proof')) {
      initReviewsProof();
    }
  });
})();
